<ng-container *ngIf='sortedAWbs && sortedAWbs.length > 0, else noAWBs'>
  <mat-card class='mat-elevation-z0'>
    <mat-card-content class='pt--none'>
      <div class='row'>
        <div class='column--12'>
          <div class='responsive-table'>
            <table mat-table [dataSource]="sortedAWbs" class="mat-elevation-z0" matSort (matSortChange)="sortData($event)">
              <ng-container matColumnDef="shipmentCreatedAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style='width: 20%'>Shipment Created</th>
                <td mat-cell class='text--sm' *matCellDef="let element" notranslate>
                  {{ element.createdAt | timeToString : DATE_FORMAT : defaultTimezone }}
                </td>
              </ng-container>
              <ng-container matColumnDef="awbNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style='width: 20%'>AWB Number</th>
                <td mat-cell class='text--sm' *matCellDef="let element" notranslate>
                  <span class='text--primary-green' style='cursor: pointer' (click)='openTrackingFromAWB(element)'>
                    {{ element.awbNumber }}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="lastMileProvider">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style='width: 20%'>Last Mile Partner</th>
                <td mat-cell class='text--sm' *matCellDef="let element" notranslate>
                  {{ element.lastMileProviderName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="destinationAirport">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Destination Airport Code</th>
                <td mat-cell class='text--sm' *matCellDef="let element" notranslate>
                  {{ element.destinationAirport }}{{ element.awbNumber.startsWith('MAAC') ? ' (Local)' : ''}}
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef style='width: 15%'></th>
                <td mat-cell class='text--sm' class='align-right' *matCellDef="let awb">
                  <ng-container>
                    <button mat-icon-button [matMenuTriggerFor]="invoiceMenu" aria-label="Invoice actions" color='primary'>
                      <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #invoiceMenu="matMenu">
                      <button mat-menu-item (click)="downloadAwb(awb, true)">
                        <span>Preview PDF</span>
                      </button>

                      <button mat-menu-item (click)="downloadAwb(awb)">
                        <span>Download PDF</span>
                      </button>

                      <button mat-menu-item class='border-top text-danger' (click)='update(awb)' [disabled]="!canEditAwb">
                        <span>Update AWB</span>
                      </button>
                    </mat-menu>
                  </ng-container>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
<ng-template #noAWBs>
  <div class='row justify-content-center'>
    <div class='column--12 align-center'>
      <div style='width: 220px; margin: 0 auto;'>
        <img src='{{ CDN_URL }}/admin/images/empty-history_animated.svg' />
        <p>No awbs found for this location</p>
      </div>
    </div>
  </div>
</ng-template>
